import gql from 'graphql-tag';

const RecipesQuery = {
  getRecipesWithFilters: gql`
    query getRecipesWithFilters(
      $author: String
      $naznachenie: Int
      $obrabotka: Int
      $bludo: Int
      $slozhnost: Int
      $type: Int
      $page: Int
      $setLimit: Int
      $search: String
      $isProductPromo: Boolean
      $productsPromoIds: [Int!]!
    ) {
      getRecipesWithFilters(
        author: $author
        naznachenie: $naznachenie
        obrabotka: $obrabotka
        bludo: $bludo
        slozhnost: $slozhnost
        type: $type
        page: $page
        setLimit: $setLimit
        search: $search
        isProductPromo: $isProductPromo
        productsPromoIds: $productsPromoIds
        imageSizeFilter: "w800"
      ) {
        promoBludoProducts {
          id
          title
          title_en
        }
        promoBludoItems {
          id
          title
        }
        typesItems {
          id
          title
        }
        slozhnostItems {
          id
          title
        }
        bludoItems {
          id
          title
        }
        obrabotkaItems {
          id
          title
        }
        naznachenieItems {
          id
          title
        }
        totalCount
        recipeItems {
          id
          isFavorite
          title
          identifyIdURI
          rating
          text
          comments_number
          date
          author
          is_product_promo
          video_code
          authorItem {
            identify
            title
            fio
            text
            active
          }
          recipes_difficult #  иконка с шапкой повара. от 1-го до 5
          slozhnostItem {
            id
            title
          }
          cooking_time # время приготовления
          rating # если 0, то "не оценен" https://www.delikateska.ru/recipes/1775
          serving # порции
          attachmentsItem {
            cacheItem {
              filePath # путь карлито
            }
          }
          bludoItem {
            id
            title
          }
        }
      }
    }
  `,
  getAuthorRecipes: gql`
    query getAuthorRecipes($author: String, $page: Int, $setLimit: Int) {
      getRecipesWithFilters(
        author: $author
        page: $page
        imageSizeFilter: "w800"
        setLimit: $setLimit
      ) {
        totalCount
        bludoItems {
          id
          title
        }
        recipeItems {
          id
          isFavorite
          title
          identifyIdURI
          rating
          text
          comments_number
          date
          author
          is_product_promo
          video_code
          authorItem {
            identify
            title
            fio
            active
          }
          recipes_difficult #  иконка с шапкой повара. от 1-го до 5
          slozhnostItem {
            id
            title
          }
          cooking_time # время приготовления
          rating # если 0, то "не оценен" https://www.delikateska.ru/recipes/1775
          serving # порции
          attachmentsItem {
            cacheItem {
              filePath # путь карлито
            }
          }
          bludoItem {
            id
            title
          }
        }
      }
    }
  `,
  getRecipesCategories: gql`
    query getRecipesCategories(
      $author: String
      $naznachenie: Int
      $obrabotka: Int
      $bludo: Int
      $slozhnost: Int
      $type: Int
      $page: Int
      $setLimit: Int
      $search: String
    ) {
      getRecipesWithFilters(
        author: $author
        naznachenie: $naznachenie
        obrabotka: $obrabotka
        bludo: $bludo
        slozhnost: $slozhnost
        type: $type
        page: $page
        setLimit: $setLimit
        search: $search
        imageSizeFilter: "w800"
      ) {
        bludoItems {
          id
          title
        }
      }
    }
  `,
  getRecipesPopular: gql`
    query getRecipesPopular($setLimit: Int, $excludeIds: [Int!]) {
      getRecipesPopular(
        setLimit: $setLimit
        excludeIds: $excludeIds
        imageSizeFilter: "w800"
      ) {
        id
        isFavorite
        title
        rating
        author
        is_product_promo
        video_code
        comments_number
        # text
        date
        identifyIdURI
        recipes_difficult #  иконка с шапкой повара. от 1-го до 5
        slozhnostItem {
          id
          title
        }
        cooking_time # время приготовления
        rating # если 0, то "не оценен" https://www.delikateska.ru/recipes/1775
        serving # порции
        bludoItem {
          id
          title
        }
        attachmentsItem {
          cacheItem {
            filePath # путь карлито
          }
        }
      }
    }
  `,
  getRecipeById: gql`
    query getRecipeById($id: Float!) {
      getRecipeById(id: $id, imageSizeFilter: "w800") {
        id
        # ЭТАП 3 п.3 — канонизация адреса рецепта: /recipes/<id> и
        # /recipes/<чужой-slug>-<id> обязаны отдавать 301 на /recipes/
        # <identify>-<id> (см. routing/recipes/$id.tsx). Раньше поле не
        # запрашивалось, потому что странице оно было не нужно.
        identify
        tip
        isFavorite
        title
        rating
        rating_votes
        author
        calories
        protein
        is_product_promo
        video_code
        date
        fat
        bludoItem {
          id
          title
        }
        carbohydrates
        viewCount
        authorItem {
          identify
          title
          fio
          text
          active
          userItem {
            attachmentsItem {
              tempFullFilePath
            }
          }
        }
        comments_number
        text
        _votedRating
        date
        typesItem {
          title
        }
        recipes_difficult #  иконка с шапкой повара. от 1-го до 5
        slozhnostItem {
          id
          title
        }
        cooking_time # время приготовления
        rating # если 0, то "не оценен" https://www.delikateska.ru/recipes/1775
        serving # порции
        attachmentsItem {
          cacheItem {
            filePath # путь карлито
          }
        }
        recipeIngredients {
          id
          title
          value
          ##!! Всегда брать первый элемент !!##
          ingredientsItems {
            catalogItem {
              id
              available
              gds_count
              currentPriceField
              currentPriceField2
              symbolPriceField
              symbolPriceField2
              fileItem {
                cacheItem {
                  filePath # картинка  товара
                }
              }
              ## catalogItem('list')
            }
          }
        }
        recipeInstructions {
          id
          title # описание инструкции
          mainImage(filter: "w1200h1600")
          thumbnail: mainImage(filter: "w600h800")
        }
      }
    }
  `,
  getRecipeCommentsByRecipeId: gql`
    query getRecipeCommentsByRecipeId(
      $cartToken: String!
      $id: ID!
      $page: Float
      $setLimit: Float
    ) {
      getRecipeCommentsByRecipeId(
        cartToken: $cartToken
        id: $id
        page: $page
        setLimit: $setLimit
      ) {
        totalCount
        recipeCommentsItem {
          peopleItem {
            id
            fio
            attachmentsItem {
              cacheItem {
                filePath
              }
            }
          }
          id
          text
          date
          answer
          answer_date
          answerUserItem {
            fio
            firstname
            secondname
            attachmentsItem {
              cacheItem {
                id
                filePath
              }
            }
          }

          photos {
            id
            thumb
            big
            isVideo
            video {
              title
              file
              width
              height
              converted
            }
          }
        }
      }
    }
  `,
  getRecipesFilters: gql`
    query getRecipesFilters {
      getRecipesFilters {
        typesItems {
          id
          title
        }
        slozhnostItems {
          id
          title
        }
        bludoItems {
          id
          title
        }
        obrabotkaItems {
          id
          title
        }
        naznachenieItems {
          id
          title
        }
      }
    }
  `,
  addRecipesItem: gql`
    mutation addRecipesItem(
      $data: RecipesInput!
      $recipeIngredients: [RecipesIngredientsInput!]!
      $recipeInstructions: [RecipesInstructionInput!]!
      $people_id: Int!
    ) {
      addRecipesItem(
        data: $data
        recipeIngredients: $recipeIngredients
        recipeInstructions: $recipeInstructions
        people_id: $people_id
      ) {
        recipeIngredients {
          id
          recipes_id
          title
          value
        }
        recipeInstructions {
          id
          title
          recipes_id
        }
        id
        people_id
        title
        author
        text
        type_id
        bludo_id
        obrabotka_id
        naznachenie_id
        cooking_time
        serving
        slozhnost_id
      }
    }
  `,
  addRecipeToFavoritesList: gql`
    mutation addRecipeToFavoritesList($data: ReciepeToFavoritesInput!) {
      addRecipeToFavoritesList(data: $data) {
        result
      }
    }
  `,
  removeRecipeFromFavoritesList: gql`
    mutation removeRecipeFromFavoritesList($data: ReciepeToFavoritesInput!) {
      removeRecipeFromFavoritesList(data: $data) {
        result
      }
    }
  `,
  voteForArticle: gql`
    mutation voteForArticle($data: VoteForArticleInput!, $cartToken: String) {
      voteForArticle(data: $data, cartToken: $cartToken) {
        id
        rating
        rating_votes
        date
        _votedRating
      }
    }
  `,
  voteForRecipe: gql`
    mutation voteForRecipe($data: VoteForRecipeInput!, $cartToken: String) {
      voteForRecipe(data: $data, cartToken: $cartToken) {
        id
        people_id
        rating
        rating_votes
        _votedRating
      }
    }
  `,
  getAuthor: gql`
    query getAuthor($identify: String!) {
      getAuthor(identify: $identify) {
        id
        identify
        title
        fio
        text
        active
        userItem {
          attachmentsItem {
            tempFullFilePath
          }
        }
        #instagram
        #facebook
        vk
        youtube
      }
    }
  `
};

export default RecipesQuery;
